import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { DocumentContainer, DocumentList, DocumentResponse, DocumentTemplateListResponse, ConfigDocumentsResponse, ConfigDocuments, DocumentBinaryPDF, DocumentTypeResponse, DocType, DocumentResponseList, GenerateContractsAzure, GenerateContractsAzureResponse, ContractsAzureDetailsResponse, PrintDocAzure, DocSignAudit, Holidays, SingnatureResponse, Holiday, DocumentsMedia, AzureMedia } from '../models/document.model';
import { DocumentSignature, DocumentSignatureResponse } from '../models/documentSignature.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class DocumentService {
    private baseUrl: string;
    private api: string = "api/Document";

    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    private handleErrors(errorResponse: HttpErrorResponse) {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error('Document Service Client Side Error: ', errorResponse.error.message);
        } else {
            throw errorResponse;
        }

        //return throwError("There is a problem with the service. We are notified & working on it. Please try again later.");
    }

    async getDocumentTemplateListAsync(encryptedUser: string): Promise<DocumentTemplateListResponse | void> {
        const a = await this.httpClient
            .get<DocumentTemplateListResponse>(`${this.baseUrl}/GetDocumentTemplateList/`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "", encryptedUser, "DocumentService", "getDocumentTemplateListAsync"); });

        return a;
    }

    async getConfigDetailsAsync(encryptedUser: string): Promise<ConfigDocumentsResponse | void> {
        const a = await this.httpClient
            .get<ConfigDocumentsResponse>(`${this.baseUrl}/GetConfigDetails/`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "", encryptedUser, "DocumentService", "getConfigDetailsAsync"); });

        return a;
    }

    async getGetDocumentTypeConfigAsync(encryptedUser: string): Promise<DocumentTypeResponse | void> {
        const a = await this.httpClient
            .get<DocumentTypeResponse>(`${this.baseUrl}/GetDocumentTypeConfig/`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "", encryptedUser, "DocumentService", "getGetDocumentTypeConfigAsync"); });

        return a;
    }

    async saveDocumentTypeAsync(doclist: DocType[], encryptedUser: string, clpUserId: number, contractType: string): Promise<DocumentTypeResponse | void> {
        //const a = await this.httpClient.post<DocumentTypeResponse>(`${this.baseUrl}/SaveDocumentType/${clpUserId}`, doclist, {
        const a = await this.httpClient.post<DocumentTypeResponse>(`${this.baseUrl}/SaveDocumentType/${clpUserId}/${contractType}`, doclist, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        })//.pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "clpUserId - " + clpUserId, encryptedUser, "DocumentService", "saveDocumentTypeAsync"); });
            .toPromise().catch(err => { this.handleErrors(err) });

        return a;
    }

    async updateConfigDetailsAsync(configDocs: ConfigDocuments, encryptedUser: string): Promise<ConfigDocumentsResponse | void> {
        const a = await this.httpClient.post<ConfigDocumentsResponse>(`${this.baseUrl}/SaveConfigDetails/`, configDocs, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, configDocs, "", encryptedUser, "DocumentService", "updateConfigDetailsAsync"); });


        return a;
    }

    async getDocumentAsync(encryptedUser: string, documentTypeId: number, inventionId: number, contactId: number, wizardId: number): Promise<DocumentResponse | void> {
        const a = await this.httpClient
            .get<DocumentResponse>(`${this.baseUrl}/GetDocument/${documentTypeId}/${inventionId}/${contactId}/${wizardId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "documentTypeId - " + documentTypeId + " inventionId - " + inventionId + " contactId - " + contactId + " wizardId - " + wizardId, encryptedUser, "DocumentService", "getDocumentAsync"); });


        return a;
    }

    async getProductDocumentListAsync(encryptedUser: string, documentTypeId: string, inventionId: number, contactId: number, contractSessionId: number, contractType: string): Promise<DocumentResponseList | void> {
        const a = await this.httpClient
            .get<DocumentResponseList>(`${this.baseUrl}/GetProductDocuments/${documentTypeId}/${inventionId}/${contactId}/${contractSessionId}/${contractType}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "documentTypeId - " + documentTypeId + " inventionId - " + inventionId + " contactId - " + contactId + " contractSessionId - " + contractSessionId, encryptedUser, "DocumentService", "getProductDocumentListAsync"); });


        return a;
    }

    getProductDocumentList(encryptedUser: string, documentTypeId: string, inventionId: number, contactId: number, contractSessionId: number): Observable<DocumentResponseList> {
        return this.httpClient
            .get<DocumentResponseList>(`${this.baseUrl}/GetProductDocuments/${documentTypeId}/${inventionId}/${contactId}/${contractSessionId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp(10000), catchError(err => { return this._utilityService.handleErrors(err, null, "documentTypeId - " + documentTypeId + " inventionId - " + inventionId + " contactId - " + contactId + " contractSessionId - " + contractSessionId, encryptedUser, "DocumentService", "getProductDocumentList"); }));
    }

    async getGetDocumentPDFBinaryAsync(encryptedUser: string, documentTypeId: string, inventionId: number, contactId: number, contractSessionId: number, contractType: string): Promise<any | void> {
        const a = await this.httpClient
            .get<any>(`${this.baseUrl}/GetDocumentPDFBinary/${documentTypeId}/${inventionId}/${contactId}/${contractSessionId}/${contractType}`, {
                'responseType': 'arraybuffer' as 'json',
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "documentTypeId - " + documentTypeId + " inventionId - " + inventionId + " contactId - " + contactId + " contractSessionId - " + contractSessionId, encryptedUser, "DocumentService", "getGetDocumentPDFBinaryAsync"); });

        return a;
    }

    async getGetDocumentZipAsync(encryptedUser: string, documentTypeId: string, inventionId: number, contactId: number, contractSessionId: number, contractType: string): Promise<any | void> {
        const a = await this.httpClient
            .get<any>(`${this.baseUrl}/GetDocumentZip/${documentTypeId}/${inventionId}/${contactId}/${contractSessionId}/${contractType}`, {
                'responseType': 'arraybuffer' as 'json',
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "documentTypeId - " + documentTypeId + " inventionId - " + inventionId + " contactId - " + contactId + " contractSessionId - " + contractSessionId, encryptedUser, "DocumentService", "getGetDocumentZipAsync"); });

        return a;
    }

    async getGetDocumentZipEncriptAsync(encryptedUser: string, documentTypeId: string, inventionId: number, contactId: number, contractSessionId: string, contractType: string): Promise<any | void> {
        const a = await this.httpClient
            .get<any>(`${this.baseUrl}/GetDocumentZipEncrypted/${documentTypeId}/${inventionId}/${contactId}/${contractSessionId}/${contractType}`, {
                'responseType': 'arraybuffer' as 'json',
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "documentTypeId - " + documentTypeId + " inventionId - " + inventionId + " contactId - " + contactId + " contractSessionId - " + contractSessionId, encryptedUser, "DocumentService", "getGetDocumentZipEncriptAsync"); });

        return a;
    }

    async sendToCorpOrEmailDocuments(encryptedUser: string, documentsMedia: DocumentsMedia): Promise<any | void> {
        const a = await this.httpClient
            .post<any>(`${this.baseUrl}/SendToCorpOrEmailDocuments/`, documentsMedia, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contractSessionId - " + documentsMedia.contractSessionId, encryptedUser, "DocumentService", "sendToCorpOrEmailDocuments"); });
        //.toPromise().catch(err => { this.handleErrors(err) });

        return a;
    }

    async getDocumentSignatureAsync(encryptedUser: string, contractSessionId: number): Promise<DocumentSignatureResponse | void> {
        const a = await this.httpClient
            .get<DocumentSignatureResponse>(`${this.baseUrl}/GetDocumentSignatures/${contractSessionId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contractSessionId - " + contractSessionId, encryptedUser, "DocumentService", "getDocumentSignatureAsync"); });


        return a;
    }

    async saveDocumentAsync(document: DocumentContainer, encryptedUser: string): Promise<DocumentResponse | void> {
        const a = await this.httpClient.post<DocumentResponse>(`${this.baseUrl}/SaveDocument/`, document, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, document, "", encryptedUser, "DocumentService", "saveDocumentAsync"); });


        return a;
    }

    async updateDocumentAsync(document: DocumentContainer, encryptedUser: string): Promise<DocumentResponse | void> {
        const a = await this.httpClient.post<DocumentResponse>(`${this.baseUrl}/UpdateDocument/`, document, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, document, "", encryptedUser, "DocumentService", "updateDocumentAsync"); });


        return a;
    }

    async exportDocumentAsync(documents: DocumentList, encryptedUser: string): Promise<DocumentResponse | void> {
        const a = await this.httpClient.post<DocumentResponse>(`${this.baseUrl}/ExportDocument/`, documents, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, documents, "", encryptedUser, "DocumentService", "exportDocumentAsync"); });


        return a;
    }

    async getFileNumber(ContractSessionId: number, encryptedUser: string): Promise<string | void> {
        const a = await this.httpClient
            .get<string>(`${this.baseUrl}/GetFileNumber/${ContractSessionId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "ContractSessionId - " + ContractSessionId, encryptedUser, "DocumentService", "exportDocumentAsync"); });


        return a;
    }

    async calculateBusinessDay(workingDays: number, newDate: string, encryptedUser: string): Promise<string | void> {
        const a = await this.httpClient
            .get<string>(`${this.baseUrl}/CalculateBusinessDay/${workingDays}/${newDate}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "workingDays - " + workingDays + " newDate - " + newDate, encryptedUser, "DocumentService", "exportDocumentAsync"); });


        return a;
    }


    async createContractAzureAsync(GenerateDocs: GenerateContractsAzure, encryptedUser: string): Promise<GenerateContractsAzureResponse | void> {
        const a = await this.httpClient.post<GenerateContractsAzureResponse>(`${this.baseUrl}/SaveDocumentAzureDetails/`, GenerateDocs, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, GenerateDocs, "", encryptedUser, "DocumentService", "createContractAzureAsync"); });

        return a;
    }

    async getContractsAzureDetailsAsync(encryptedUser: string, contractsessionId: number): Promise<ContractsAzureDetailsResponse | void> {
        const a = await this.httpClient
            .get<ContractsAzureDetailsResponse>(`${this.baseUrl}/GetDocumentAzureDetails/${contractsessionId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contractsessionId - " + contractsessionId, "DocumentService", "getContractsAzureDetailsAsync"); });

        return a;
    }

    async getContractsAzureDetailsAllAsync(encryptedUser: string): Promise<ContractsAzureDetailsResponse | void> {
        const a = await this.httpClient
            .get<ContractsAzureDetailsResponse>(`${this.baseUrl}/GetDocumentAzureDetailsAll`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "DocumentService", "getContractsAzureDetailsAllAsync"); });

        return a;
    }

    async getLatestContractsAzureDetailsAsync(encryptedUser: string, contractsessionId: number): Promise<ContractsAzureDetailsResponse | void> {
        const a = await this.httpClient
            .get<ContractsAzureDetailsResponse>(`${this.baseUrl}/GetLatestContractAzureDetails/${contractsessionId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contractsessionId - " + contractsessionId, "DocumentService", "getContractsAzureDetailsAsync"); });

        return a;
    }

    async getContractsAzureZipEncriptAsync(encryptedUser: string, zipName: string, containerName: string, fileName: string, contractSessionId: number, isCustDocument: boolean): Promise<any | void> {
        const a = await this.httpClient
            .get<any>(`${this.baseUrl}/GetAzureFileDownloadasync/${zipName}/${containerName}/${fileName}/${contractSessionId}/${isCustDocument}`, {
                'responseType': 'arraybuffer' as 'json',
                headers: new HttpHeaders({
                    'responseType': 'arraybuffer',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "fileName - " + fileName, encryptedUser, "DocumentService", "getContractsAzureZipEncriptAsync"); });

        return a;
    }
    async getCompressedFileNamesAsync(encryptedUser: string, fileName: string, containerName: string, contractSessionId: number, isCustDocument: boolean): Promise<string | void> {
        const a = await this.httpClient
            .get<string>(`${this.baseUrl}/GetCompressedFileNames/${fileName}/${containerName}/${contractSessionId}/${isCustDocument}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "fileName - " + fileName, encryptedUser, "DocumentService", "getCompressedFileNamesAsync"); });

        return a;
    }
    async updateGenerateContractsAzureIDSAsync(encryptedUser: string, printDocAzure: PrintDocAzure[]): Promise<PrintDocAzure | void> {
        const a = await this.httpClient.post<PrintDocAzure>(`${this.baseUrl}/GenerateContractsAzure_UpdateDocIDS`, printDocAzure, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).toPromise().catch(err => { this.handleErrors(err) });

        return a;
    }

    async saveDocSignAuditAsync(doSign: DocSignAudit, encryptedUser: string): Promise<void> {
        const a = await this.httpClient.post(`${this.baseUrl}/SaveDocSignAudit`, doSign, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).toPromise().catch(err => { this.handleErrors(err) });

    }

    async getHolidayListByYear(year: number, encryptedUser: string): Promise<Holiday[] | void> {
        const a = await this.httpClient
            .get<Holiday[]>(`${this.baseUrl}/GetHolidayListByYear/${year}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "year - " + year, encryptedUser, "DocumentService", "getHolidayListByYear"); });

        return a;
    }

    async getSignatureList(csId: number, encryptedUser: string): Promise<SingnatureResponse | void> {
        const a = await this.httpClient
            .get<SingnatureResponse>(`${this.baseUrl}/GetSingListByCSId/${csId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "csId - " + csId, encryptedUser, "DocumentService", "GetSingListByUser"); });

        return a;
    }

    async checkSignAsync(document: DocumentContainer, encryptedUser: string): Promise<DocumentResponse | void> {
        const a = await this.httpClient.post<DocumentResponse>(`${this.baseUrl}/CheckDocumentSign/`, document, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, document, "", encryptedUser, "DocumentService", "saveDocumentAsync"); });


        return a;
    }


    async getROIVideoURL(azureMedia: AzureMedia, encryptedUser: string): Promise<string | void> {
        const a = await this.httpClient
            .post<string>(`${this.baseUrl}/GetROIVideoURL/`, azureMedia, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "contractSessionId - " + azureMedia.contractSessionId + " fileName - " + azureMedia.fileName, encryptedUser, "DocumentService", "getROIVideoURL"); });
        return a;
    }
}
